import { Bets } from '../../../config/bets';

export interface GameResultType {
  result: number;
}
export interface EarlyBetType {
  betCode: Bets;
  amount: number;
}
export interface CashedAmountType {
  betCode: Bets;
  amount: number;
}

export enum winStates {
  cashed = 'cashed',
  youWin = 'win',
}

